/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funny_Curly_Donkey_EnchantInputs */

const es_funny_curly_donkey_enchant = /** @type {(inputs: Funny_Curly_Donkey_EnchantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y preparate para navegar!`)
};

const gl_funny_curly_donkey_enchant = /** @type {(inputs: Funny_Curly_Donkey_EnchantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e prepárate para navegar!`)
};

const en_funny_curly_donkey_enchant = /** @type {(inputs: Funny_Curly_Donkey_EnchantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nd get ready to set sail!`)
};

/**
* | output |
* | --- |
* | "nd get ready to set sail!" |
*
* @param {Funny_Curly_Donkey_EnchantInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const funny_curly_donkey_enchant = /** @type {((inputs?: Funny_Curly_Donkey_EnchantInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funny_Curly_Donkey_EnchantInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_funny_curly_donkey_enchant(inputs)
	if (locale === "en") return en_funny_curly_donkey_enchant(inputs)
	return es_funny_curly_donkey_enchant(inputs)
});